import { motion, useReducedMotion } from 'framer-motion';
import { ArrowUpRight } from 'lucide-react';
import { Button } from '../ui/button';

export const Sparkle = ({ className = '', ...props }) => (
  <svg viewBox="0 0 100 100" fill="none" className={className} aria-hidden="true" {...props}>
    <path d="M50 0C55 29 71 45 100 50C71 55 55 71 50 100C45 71 29 55 0 50C29 45 45 29 50 0Z" fill="currentColor" />
  </svg>
);

export const Reveal = ({ children, className = '', delay = 0, ...props }) => {
  const reduced = useReducedMotion();
  return <motion.div className={className} initial={reduced ? false : { opacity: 0, y: 30 }}
    whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.12 }}
    transition={{ duration: 0.75, delay, ease: [0.22, 1, 0.36, 1] }} {...props}>{children}</motion.div>;
};

export const ActionLink = ({ href, children, className = '', testId, ...props }) => (
  <Button asChild className={`action-link ${className}`}>
    <a href={href} data-testid={testId} {...props}>{children}<span className="action-icon"><ArrowUpRight size={18} /></span></a>
  </Button>
);

export const SectionLabel = ({ number, children, light = false, testId }) => (
  <div className={`section-label ${light ? 'on-dark' : ''}`} data-testid={testId}>
    <span className="label-mark" />{children}<span className="section-number">/ {number}</span>
  </div>
);